import React, { useRef, useState } from 'react';
import { Button } from 'quantux-ui';
import { css, StyleSheet } from 'aphrodite/no-important';
import QuantuxCam from '../quantux-cam';
import { gray, salmon } from '../../theme';

const CameraContainer = (props) => {
  const cameraRef = useRef(false);

  // const camHeight = window.innerHeight - 200;
  // const camWidth = camHeight * 0.70707071;

  let camHeight = 8000;
  let camWidth = 0;
  let diff = 40;
  while (camHeight > window.innerHeight - 200) {
    camWidth = Math.min(window.innerWidth - diff);
    camHeight = camWidth / 0.70707071;
    diff = diff + 20;
  }

  const [showCamErrorHandler, setShowCamErrorHandler] = useState(false);

  // const camHeight = camWidth / 0.70707071;

  const styles = StyleSheet.create({
    cameraContainer: {
      position: 'relative',
      height: `${window.innerHeight}px`
    },
    cameraContainerHeader: {
      height: '80px',
      background: gray[500]
    },
    cameraSection: {
      position: 'relative',
      width: `${camWidth}px`,
      height: `${camHeight}px`,
      // top: '20px',
      top: `${(window.innerHeight - 160) / 2 - (camHeight / 2)}px`,
      left: `${(window.innerWidth) / 2 - (camWidth / 2)}px`
    },
    footer: {
      position: 'fixed',
      paddingRight: '8px',
      right: '0',
      bottom: '0px',
      height: '80px',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      background: gray[500],
      justifyContent: 'center'
    },
    scanButtonContainer: {
      // flexGrow: '1',
      // flexShrink: '1',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'calc(100vw - 100px)'
    },
    scanButton: {
      borderRadius: '50%',
      border: '1px solid black',
      background: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '45px',
      height: '45px',
      fontSize: '16px',
      cursor: 'pointer'
    },
    camErrCloseBtn: {
      color: gray[300],
      position: 'absolute',
      top: '4px',
      right: '4px',
      fontSize: '24px',
      ':hover': {
        color: salmon[500]
      }
    }
  });

  return (
    <div className={css(styles.cameraContainer)}>
      {showCamErrorHandler &&
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100vw',
            height: '96px',
            background: 'black',
            zIndex: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: '0.90',
            boxShadow: '0px 2px 4px rgba(24, 72, 120, 0.5)'
          }}
        >
          <i
            className={`fa fa-times-circle ${css(styles.camErrCloseBtn)}`}
            onClick={() => {
              setShowCamErrorHandler(false);
              props.onCancel();
            }}
          />
          <Button
            bntType='primary'
            onClick={() => {
              setShowCamErrorHandler(false);
              location.reload();
            }}
          >
            <i className='mr-2 fa fa-refresh' style={{ fontSize: '1.25rem' }}/>
            Reload Page and Try again!
          </Button>
        </div>
      }
      <div className={css(styles.cameraContainerHeader)}>
        <div
          className='pl-2  pr-2'
          style={{
            height: '40px',
            borderBottom: `1px solid ${gray[800]}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: gray[200]
          }}
        >
          <div
            style={{
              flexGrow: '1',
              textAlign: 'center',
              paddingLeft: '24px'
            }}
          >
            {props.title}
          </div>
          <i
            className='fa fa-times-circle'
            style={{ fontSize: '24px' }}
            onClick={props.onCancel}
          />
        </div>
        <div
          className='fx fx__hv-center'
          style={{ color: gray[200], height: '40px' }}
        >
          {props.isReScan
            ? `ReScan Page ${props.activeIndex + 1}`
            : `Scan Page ${props.images.length + 1}`
        }
        </div>
      </div>
      <div className={css(styles.cameraSection)}>
        <QuantuxCam
          ref={cameraRef}
          facingMode='environment'
          fixError={(msg) => {
            console.log('Quantux Cam error handler!');
            console.log(msg);
            setShowCamErrorHandler(true);
          }}
          errorMessages={{
            // noCameraAccessible: 'No camera device accessible OR Permission denied. Please refresh and give camera permission.',
            noCameraAccessible: 'Camera is not accessible as you have denied permission. Please refresh and give camera permission.',
            permissionDenied: 'Permission denied. Please refresh and give camera permission.',
            switchCamera: 'It is not possible to switch camera to different one because there is only one video device accessible.',
            canvas: 'Canvas is not supported.'
          }}
        />
        <div
          style={{
            position: 'fixed',
            // width: '540px',
            // height: '700px',
            width: `${camWidth}px`,
            height: `${camHeight}px`,
            border: '2px solid red',
            top: `${window.innerHeight / 2 - (camHeight / 2)}px`,
            left: `${(window.innerWidth) / 2 - (camWidth / 2)}px`
          }}
        />
      </div>
      <div className={css(styles.footer)}>
        {/* Edit mode thumbnail */}
        {props.images.length > 0 &&
          <div
            className='pl-4'
            onClick={props.onEdit}
            style={{
              position: 'relative'
            }}
          >
            <div
              style={{
                position: 'relative',
                borderRadius: '50%',
                background: 'red',
                color: 'white',
                width: '20px',
                height: '20px',
                top: '15px',
                left: '24px',
                zIndex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px'
              }}
            >
              {props.images.length}
            </div>
            <img
              src={props.images[0]}
              alt='First image thumbnail'
              style={{
                position: 'relative',
                height: '40px',
                width: 'auto'
              }}
            />
          </div>
        }
        <div
          className={css(styles.scanButtonContainer)}
          style={{
            paddingLeft: props.images.length > 0 ? '0' : '91px'
          }}
        >
          <div
            style={{
              background: 'white',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div
              className={css(styles.scanButton)}
              onClick={() => props.onScan(cameraRef.current.takePhoto())}
            >
              Scan
            </div>
          </div>
        </div>
        {props.showManual &&
          <Button
            className='ml-2'
            btnType='primary'
            onClick={props.onManual}
          >
            Skip
          </Button>
        }
        <Button
          className='ml-2'
          style={{ padding: '0', color: 'white', fontWeight: 'bold' }}
          btnType='primary'
          onClick={() => {
            if (props.showCancel) {
              props.onCancel();
            } else {
              props.onSkip();
            }
          }}
        >
          {props.showCancel ? 'Cancel' : 'Save & Finish'}
        </Button>
      </div>
    </div>
  );
};

CameraContainer.defaultProps = {
  images: [],
  showManual: false,
  isReScan: false,
  activeIndex: 0
};

export default CameraContainer;
